import { actionTypes } from './actions';

import initialState from './initialState';

export default function accessibilityReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SHOW_MODAL:
      return state.set('showModal', true);
    case actionTypes.HIDE_MODAL:
      return state.set('showModal', false);
    case actionTypes.SET_BODY_CLASS:
      return state.set('bodyClass', action.payload);
    default:
      return state;
  }
}
